import { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import { imageCodes, textCodes, titleCodes, videoCodes } from "../../template_codes/herdotandco/about_page_codes";

function About() {
    const [showTab, setShowTab] = useState(false)
    return (
        <React.Fragment>
            <div className="font-quicksand" data-theme="weireframe">
                <div class="navbar ">
                    <div class="navbar-start">

                    </div>
                    <div class="navbar-center lg:flex">
                        <ul class="menu menu-horizontal p-0">
                            <li className="p-2"><Link to={paths.home}>Home</Link></li>
                            <li><a href="https://herandcomm.com/">Shop</a></li>
                            <li className="p-2"><Link to={paths.about}>About Us</Link></li>
                            <li className="p-2"><Link to={paths.contact}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="navbar-end"></div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 font-quicksand pt-20">
                    <div className="px-10 ">
                        <h1 className="text-xl justify-between lg:text-2xl xl:text-2xl font-semibold pb-10">{textCodes.aboutus.text}</h1>
                        <li className="text-md justify-between list-none pt-2 lg:text-md xl:text-md pb-2">{textCodes.aboutus1.text}</li>
                        <li className="text-md justify-between list-none pt-2 lg:text-md xl:text-md pb-2">{textCodes.aboutus2.text}</li>
                        <li className="text-md justify-between list-none pt-2 lg:text-md xl:text-md pb-2">{textCodes.aboutus3.text}</li>
                        <li className="text-md justify-between list-none pt-2 lg:text-md xl:text-md pb-2">{textCodes.aboutus4.text}</li>
                    </div>
                    <div className="px-2">
                        <div className="pt-10 lg:pt-0 xl:pt-0">
                            <img src={imageCodes.about.image}></img>
                        </div>
                    </div>
                </div>

                {/*                        love note section                        */}
                <div className="w-fix">
                    <div className="pt-10 lg:pt-10 xl:pt-10">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title6.title}</h1>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-4 pb-20 lg:px-20 xl:px-20 px-4">
                        <div className="lg:pr-2 xl:pr-2 focus-visible">
                            <img src={imageCodes.love.image}></img>
                            <a href="https://herandcomm.com/product/CyMj3gtPdgdjXibm0uhL"><p className="py-4 hover:animate-bounce"></p></a>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.love1.image}></img>
                            <a href="https://herandcomm.com/product/sGJg3r9VsbnUkQAXol2k"><p className="py-4 hover:animate-bounce"></p></a>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.love2.image}></img>
                            <a href="https://herandcomm.com/product/cl4wcxsie6791601s6xum6r2m6"><p className="py-4 hover:animate-bounce"></p></a>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.love3.image}></img>
                            <a href="https://herandcomm.com/product/cl4wcxsie6791601s6xum6r2m6"><p className="py-4 hover:animate-bounce"></p></a>
                        </div>
                    </div>
                </div>
                {/*                        end of love note section                */}

                {/*                        recom section                        */}
                <div className="w-fix">
                    <div className="pt-10 lg:pt-10 xl:pt-10">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title7.title}</h1>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-4 pb-20 lg:px-20 xl:px-20 px-4">
                        <div className="lg:pr-2 xl:pr-2 focus-visible">
                            <img src={imageCodes.support.image}></img>
                            <div class="card-body" data-theme="valentine">
                                <h5 class="card">
                                    Dee
                                </h5>
                                <div class="card-actions justify-end">
                                    <div class="badge badge-outline">Model</div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.support1.image}></img>
                            <div class="card-body" data-theme="valentine">
                                <h5 class="card">
                                    Ariel Thuta
                                </h5>
                                <div class="card-actions justify-end">
                                    <div class="badge badge-outline">Model</div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.support2.image}></img>
                            <div class="card-body" data-theme="valentine">
                                <h5 class="card">
                                    Kacy Hsiao
                                </h5>
                                <div class="card-actions justify-end">
                                    <div class="badge badge-outline">Model</div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.support3.image}></img>
                            <div class="card-body" data-theme="valentine">
                                <h5 class="card">
                                    Rockin’
                                </h5>
                                <div class="card-actions justify-end">
                                    <div class="badge badge-outline">Model</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*                        end of recom section                */}

            </div>
        </React.Fragment>
    );
}

export default About;